<template>
    <Modal
        v-model="showModal"
        :scrollable="true"
        @on-cancel="close"
        title="Post Document">
        <span 
            style="position:absolute;right:15px;top:15px" 
            @click="close">
            <img 
                :src="closeIcon" 
                style="height: 25px;"/>
        </span>

        <div
            v-if="isTypeSelection && !isEditMode">
               <p v-for="(category, pkey) in categories"
                  :key="pkey"
                  class="post-document-item item"
                  v-on:click="itemSelected(category.label)">
                    {{ category.label }}
               </p>
        </div>

        <div
            v-else>

            <Input
                v-if="selectedCategory === 'Other' || (item.data && item.data.category === 'Other')"
                v-model="title"
                placeholder="Title" 
                style="margin-top:10px"/>

            <span
                v-else>
                <strong>
                    {{ title }}
                </strong>
            </span>

            <img 
                class="imagePreview"
                :src="image">
                
            <Input 
                placeholder="Notes"
                type="textarea" 
                v-model="notes"
                :autosize="true"
                style="margin-top:10px"/>

        </div>

        <div 
            slot="footer">
            <Button 
                @click="triggerUpload"
                v-if="!isTypeSelection || isEditMode"
                type="default" 
                icon="image" 
                style="float: left"/>
            <Button 
                v-if="!isTypeSelection && !isEditMode"
                type="text"
                @click="previous">
                Previous
            </Button>
            <Button
                v-if="!isTypeSelection || isEditMode"
                @click="validatePost"
                type="primary">
                Submit
            </Button>
        </div>

        <UploadImageComponent 
            :singleImage = "true"
            ref = "uploadImage"
            @emitBase64="processImage"/>
    </Modal>
</template>

<script>

    import UploadImageComponent from '@/components/UploadImageComponent'
    import Utils from "@/utils.js";
    import _ from 'lodash'

    export default {
        data () {
            return {
                selectedCategory: "",
                isTypeSelection: true,
                form: Cons[0].ACTIVITY,
                postImage: [],
                imageModified: false
            }
        },
        computed: {
            categories() {
                return _.orderBy(this.$store.state.user.documents.choices, 'order')
            },
            userDocuments:{
                get(){
                    return this.$store.state.user.documents.data.careplan_item
                }
            },
            notes: {
                get() {
                    return this.isEditMode ?
                        this.item.data.notes : this.form.data.notes
                },
                set(v) {
                    if (this.isEditMode)
                        this.item.data.notes = v
                    else
                        this.form.data.notes = v
                }
            },
            title: {
                get(){
                    return this.isEditMode ?
                        this.item.title : this.form.title
                },
                set(v){
                    if (this.isEditMode)
                        this.item.title = v
                    else
                        this.form.title = v
                }
            },
            image() {
                if (this.isEditMode){
                    if (this.imageModified)
                        return this.postImage[0]
                    else
                        return Utils.getDisplayImage('activity', this.item, 'medium')
                }
                else
                    return this.postImage[0]
            },
            showModal: {
                get () {
                    return this.$store.state.menu.postDocumentDialogShow
                },
                set (v) {
                    this.$store.commit("menu/setPostDocumentModal", v)
                }
            },
            updatedItem: {
                get () {
                    return this.$store.state.menu.updatedItem
                },
                set (v) {
                    this.$store.commit("user/set")
                }
            },
            closeIcon: {
                get() {
                    return require('@/assets/close.png')
                }
            },
            postImageFile: {
                get(){
                    return this.$store.state.publicModule.uploadedImage;
                }
            },
            profileInfo: {
                get() {
                    return this.$store.state.user.info;
                }
            },
            item: {
                get(){
                    return this.$store.state.user.documents.updatedItem
                },
                set(v){
                    this.$store.commit("user/setUpdatedItem", v)
                }
            },
            isEditMode(){
                return this.item.id ? true : false
            }
        },
        methods: {
            validatePost() {
                if(!Utils.verifyUser()){
                    this.$store.commit('user/showVerifyModal', true)
                    return false;
                }
                this.form.recurrence = [Utils.setRrulePostDate(new Date())];
                this.form.data_type = "content"
                this.form.timing = ["now"]
                this.form.show_dashboard = false

                    this.form.data.category = this.isEditMode ? 
                        this.item.data.category : this.selectedCategory
                    // this.form.title = this.form.data.category;
                    this.form.is_published = 1
                    this.form.type = "document"

                    if (_.isEmpty(this.form.title || this.item.title)) {
                    this.$Message({
                        closable: true,
                        title: { content:'Required' },
                        icon: 'alert',
                        message: { content: 'Please provide title' },
                        buttons: [
                        { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
                        ]
                    });
                    } else {
                        this.postUpdate();
                    }
                
            },
            postUpdate() {
                if (!this.isEditMode){
                    this.$store
                        .dispatch("feed/postCareplanUpdate", {
                            id: this.profileInfo.careplan_id,
                            data: this.form
                        })
                        .then(res => {
                            this.$Message({
                                closable: true,
                                title: { content:'Success' },
                                icon: 'alert',
                                message: { content: 'Successfully Posted' },
                                buttons: [
                                { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> {
                                    // this.$router.push({ path: '/documents'})
                                } }
                                ]
                            });
                        this.close()

                        if (!_.isEmpty(this.$store.state.resource.groupFeed.list)) {
                            this.$store.commit("feed/pushResourceGroupFeed", res.data);
                        }
                        this.$store.commit("feed/pushUserJournalFeed", res);
                    });
                    
                }
                else {
                    this.$store
                        .dispatch("feed/updateCareplanItem", this.item)
                        .then(res => {
                            
                            setTimeout(() => {
                                this.$store.commit('feed/setSingleFeed', res.data)
                                this.$store.commit('user/updateDocument', res.data) 
                            }, 800);

                            this.$Message({
                                closable: true,
                                title: { content:'Success' },
                                icon: 'alert',
                                message: { content: 'Successfully Updated' },
                                buttons: [
                                { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> "" }
                                ]
                            });
                        
                        this.close()
                    });
                }
            },
            resetSelectedItem(){
                this.item = {}
            },
            processImage(image){
                
                if (!image)
                    return

                if (this.isEditMode) 
                    this.imageModified = true

                this.isTypeSelection = false

                this.removeAttachement();
            
                this.postImage.push(image[0])

                this.$store.dispatch('publicModule/uploadBase64Image', {base64_image: image[0]})
                    .then(res => {
                        if(!_.isEmpty(this.postImageFile)){
                            if (!this.isEditMode) 
                                this.form.cover_photo = [
                                    { 
                                        day: 0,
                                        image: this.postImageFile.uploaded[0] 
                                    }
                                ]
                            else
                                this.item.cover_photo = [
                                    { 
                                        day: 0,
                                        image: this.postImageFile.uploaded[0] 
                                    }
                                ]
                        }
                    })
            },
            removeAttachement(){
                this.postImage = [];
                this.form.cover_photo = null;
                this.form.type = null;

                this.form.data.url = null;
                // this.form.data.text = null;
                this.form.data.attachment_type = null;
                this.form.data.preview_image = null;
                this.form.data.preview_summary = null;
                this.form.data.preview_title = null;

                this.$store.commit('publicModule/setUploadedImage', null);
                this.$store.commit('publicModule/setAttachement', null);
                this.$store.commit('publicModule/setHasAttachement', false);
            },
            itemSelected(v){
                this.triggerUpload()

                this.selectedCategory = v

                if (v !== "Other")
                    this.form.title = v
            },
            triggerUpload(){
                this.$refs.uploadImage.triggerUpload()
            },
            close(){
                this.showModal = false
                this.imageModified = false

                setTimeout(() => {

                    this.resetSelectedItem()
                    this.removeAttachement();
                    this.form.title = "";
                    this.form.data = {};
                    this.form.cover_photo = null;
                    this.form.type = null;
                    this.$store.commit('publicModule/setAttachement', null);
                    this.$store.commit('publicModule/setHasAttachement', false);

                    this.isTypeSelection = true
                }, 1000);

                this.$emit('close')
            },
            previous(){
                this.isTypeSelection = true
                this.selectedCategory = ""
                this.title = ""
            }
        },
        components: {
            UploadImageComponent
        }
    }
</script>

<style lang="scss">
    .item{
        padding: 8px;
        border-bottom: 1px solid #eee;
    }
    .post-document-item {
        .ivu-radio {
            display: none !important;
        }
    }
    .ivu-modal-footer {
        border-top: 1px solid #e9eaec;
    }
    .imagePreview {
        height: 100%;
        margin-top: 10px;
        width: 100%;
    }
</style>